import React from 'react'
import styled, { css } from 'styled-components'
import {
  Button,
  Modal as BaseModal,
  ModalInjectedProps,
} from '@sketch/components'
import { Image as ImageUnstyled } from '@sketch/modules-common'
import Separator from 'modules/shares/Inspector/Sidebar/components/Separator'
import selectLayer from '@sketch/icons/select-layer-video.gif'
import { ReactComponent as RulerIcon } from '@sketch/icons/rulers-64'
import { ReactComponent as SearchIcon } from '@sketch/icons/search-64'
import { ReactComponent as ColorFanIcon } from '@sketch/icons/color-fan-64'
import { ReactComponent as UploadingIcon } from '@sketch/icons/uploading-64'

const Modal = styled(BaseModal)`
  position: relative;
  display: grid;
  grid-template-rows: auto 1fr auto;
  max-height: 100%;

  > div {
    overflow: auto;
  }
`

const IntroductionModalHeader = styled(BaseModal.Header)`
  display: flex;
`

const StyledIcon = styled.svg.attrs({
  role: 'img',
})(
  ({ theme: { colors } }) => css`
    width: 64px;
    height: 64px;
    margin-right: 20px;
    color: ${colors.foreground.secondary.A};
    opacity: 0.8;
  `
)

const IntroductionItemTitle = styled.h4`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 1;
  margin: 0 0 8px 0;
`

const LayerExportGif = styled(ImageUnstyled)`
  padding-top: 16px;
  margin-bottom: 40px;
  height: 205px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const IntroSeparator = styled(Separator)`
  padding: 12px 0;
`

const IntroductionIcons = styled.div`
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  margin-top: 16px;
  padding: 28px 44px;
  display: flex;
  justify-content: space-between;
`

const IntroductionModal: React.FC<ModalInjectedProps> = ({ hideModal }) => {
  return (
    <Modal onCancel={hideModal}>
      <IntroductionModalHeader>
        How to Select a Any Layer
      </IntroductionModalHeader>
      <BaseModal.Body>
        For documents with overlapping layers, Control-click or right-click over
        the layer you want to select, then choose it from the menu.
        <LayerExportGif
          src={selectLayer}
          width={425}
          alt="Right click on a layer to trigger the contextual menu"
        />
        <IntroSeparator />
        <IntroductionItemTitle>Using the Inspector</IntroductionItemTitle>
        You can use the web Inspector to select and measure between layers, view
        layer attributes, copy values to the clipboard, and download
        production-ready assets.
        <IntroductionIcons>
          <StyledIcon as={SearchIcon} />
          <StyledIcon as={RulerIcon} />
          <StyledIcon as={ColorFanIcon} />
          <StyledIcon as={UploadingIcon} />
        </IntroductionIcons>
      </BaseModal.Body>
      <BaseModal.Footer>
        <Button onClick={hideModal} variant="primary">
          Close
        </Button>
      </BaseModal.Footer>
    </Modal>
  )
}

export default IntroductionModal
